import React, { useEffect } from "react";
//import { useMsal } from "@azure/msal-react";
import { app, authentication } from "@microsoft/teams-js";
//import { InteractionStatus } from "@azure/msal-browser";
//import { msalInstance } from "../utility/msalConfig";
// import { sendAppInvitationInChat } from "../utility/util";
// import { useNavigate } from "react-router";
import { useMsal } from "@azure/msal-react";
//import { getOS } from "../utility/util";
import { useSearchParams } from "react-router";

const AuthPage = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [searchParams] = useSearchParams();
  const teamsAuth = searchParams.get('teamsAuth');
  const loginHint = searchParams.get('loginHint');
  //const navigate = useNavigate();
  // const { instance } = useMsal();
 
   
//  useEffect(() => {
//   const runRedirect = async () => {
//     try {
//       await app.initialize();
  
//       const response = await instance.handleRedirectPromise();
//       console.log("Redirect login completed, access token:", response?.accessToken,"chatId:", localStorage.getItem('chatId'));
//       const chatId = localStorage.getItem('chatId');
//       if (response && chatId && response.accessToken) {
//         const context = {
//           subEntityId: "",
//           chatId: chatId,
//         };

//         const deeplink = `https://teams.microsoft.com/l/entity/eb3e50bb-bbbc-4815-b6ae-e861815e98c3/givent?context=${encodeURIComponent(JSON.stringify(context))}`;
//         const inv_response = await sendAppInvitationInChat(chatId, deeplink, response.accessToken);

//         if (inv_response.ok) {
//           console.log("Message sent successfully!", await inv_response.json());
//           navigate("/loadform", { state: { showDForm: true } });
//           authentication.notifySuccess(response.accessToken);
//           localStorage.removeItem('chatId'); // Clear chatId after use
//         }
//       }
//     } catch (error) {
//       console.error("Redirect or message send error:", error);
//       authentication.notifyFailure(error.message || "Auth failed");
//       localStorage.removeItem('chatId');
//     }
//   };

//   runRedirect();
// // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

useEffect(() => {
    const initializeAuth = async () => {
      await app.initialize();

      // Check for ongoing interaction
      if (inProgress !== "none") {
        await new Promise(resolve => setTimeout(resolve, 500));
        return initializeAuth(); // Retry after delay
      }

      // Handle redirect response
      const response = await instance.handleRedirectPromise();
      if (response) {
        handleAuthSuccess(response.accessToken);
        return;
      }

      // Handle Teams auth result
      if (teamsAuth) {
        try {
          const urlParams = new URLSearchParams(window.location.search);
          const authResult = urlParams.get('authResult');
          
          if (authResult) {
            const result = JSON.parse(decodeURIComponent(authResult));
            if (result.accessToken) {
              handleAuthSuccess(result.accessToken);
            } else if (result.code) {
              const tokenResponse = await instance.acquireTokenByCode({
                code: result.code,
                scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
                redirectUri: window.location.origin + '/auth'
              });
              handleAuthSuccess(tokenResponse.accessToken);
            }
          } else {
            // Ensure no other interaction is in progress
            if (inProgress === "none") {
              await instance.loginRedirect({
                scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
                loginHint: loginHint,
                redirectUri: window.location.origin + '/auth'
              });
            }
          }
        } catch (error) {
          handleAuthFailure(error);
        }
        return;
      }

      // Try silent auth
      try {
        const account = instance.getActiveAccount();
        if (account) {
          const silentToken = await instance.acquireTokenSilent({
            scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
            account
          });
          handleAuthSuccess(silentToken.accessToken);
          return;
        }
      } catch (silentError) {
        console.warn("Silent auth failed:", silentError);
      }

      // Fallback to interactive auth
      if (inProgress === "none") {
        try {
          await instance.loginRedirect({
            scopes: ["Chat.ReadWrite", "ChatMessage.Send"],
            redirectUri: window.location.origin + '/auth'
          });
        } catch (error) {
          handleAuthFailure(error);
        }
      }
    };

    initializeAuth();
}, [instance, accounts, inProgress, teamsAuth, loginHint]);


const handleAuthSuccess = (token) => {
    authentication.notifySuccess(token);
  };

  const handleAuthFailure = (error) => {
    authentication.notifyFailure(
      error instanceof Error ? error.message : "Authentication failed"
    );
  };
 if (teamsAuth) {
    return <div>Completing authentication...</div>;
  }
  return (
    <div style={{ fontFamily: "Segoe UI", padding: "2rem" }}>
      Logging you in securely via Microsoft Teams...
    </div>
  );
};

export default AuthPage;

